module.exports = __webpack_public_path__ + "img/status7-1.a7a03d55.svg";